import React, { useEffect, useState } from "react"
import AdminDialog from "./AdminDialog"
import { TextBox } from "devextreme-react";
import { CheckBox } from "devextreme-react/check-box";
import { useDispatch, useSelector } from "react-redux";
import { selectServices } from "../../redux/services/selectors";
import { RoleInput } from "./RoleInput";
import { generate } from "generate-password-browser";
import { selectRoles } from "../../redux/roles/selectors";
import { selectUserRoles, selectUserSuperAdmin } from "../../redux/authentication/selectors"
import { selectSuppliers } from "../../redux/suppliers/selectors";
import { getSuppliers } from "../../redux/suppliers/thunks";
import SelectBox from "../common/CustomSelectBox";
import { Button, Divider, Typography } from "@material-ui/core";
import addIcon from "../../images/add-icon-white.svg"
import { useTranslation } from "react-i18next";
import { PasswordInput } from "./PasswordInput";

const initialData={
    userName: "",
    roles: [{roleId: null, roleLevel: 0, serviceIds: [], externalId: generate({length: 8}) }],
    supplierId: null,
    forcePasswordChange: false,
    resetPassword: ""
}

function UserDialogue(props)
{
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {open, data, handleDialogClose, title, onSubmitOperation, operation} = props;
    const [editData, setEditData] = useState(initialData)
    const allRoles = useSelector(selectRoles)
    const allServices = useSelector(selectServices)
    const userRoles = useSelector(selectUserRoles)
    const userSuperAdmin = useSelector(selectUserSuperAdmin)
    const suppliers = useSelector(selectSuppliers)
    const userLevel = userSuperAdmin ? 100 : Math.max(...(userRoles && userRoles.length > 0 ? userRoles.map(role => role.role?.level || role.level || 0) : [0]))
    const allowedRoles = allRoles.filter(role=> role.level <= userLevel)

    useEffect(() => {
        if (open) {
            dispatch(getSuppliers())
        }
    }, [open, dispatch])

    useEffect(()=>{
        if(open && data){
            const roles = data.roles.map(role=> ({roleId: role.roleId, level: role.role?.level, externalId: generate({length: 8}), serviceIds: role.services.map(service=> service.serviceId)}))
            setEditData({userName: data.userName, userId: data.userId, roles, supplierId: data.supplierId || null, forcePasswordChange: data.forcePasswordChange || false, resetPassword: ""})
        } else {
            setEditData(initialData)
        }
    
    },[data, open])


    function handleChangeRoleService(updatedRoleService){
       const updatedData = editData.roles.map(role=> role.externalId === updatedRoleService.externalId ? updatedRoleService : role );
       setEditData(prevState=> ({...prevState, roles: updatedData}))
    }

    function handleAddRole(){
        const newRole = {roleId: null, serviceIds: [], externalId: generate({length: 8}) }
        const updatedData = [...editData.roles, newRole];
        setEditData(prevState=> ({...prevState, roles: updatedData}))
    }

    function handleDeleteRole(externalId){
        const withoutRole = editData.roles.filter(role=> role.externalId !== externalId)
        setEditData(prevState=>({...prevState, roles: withoutRole}))
    }

    function handleChangeUserName(value){
        setEditData(prevState=>({...prevState, userName: value}))
    }

    function handleChangePassword(value){
        setEditData(prevState=>({...prevState, password: value}))
    }

    function handleChangeResetPassword(value){
        setEditData(prevState=>({...prevState, resetPassword: value}))
    }

    return(
        <AdminDialog dialogSize={{height: "100%"}} operation = { operation } open ={open} onClose = { handleDialogClose } title = {title} handleOnClick = { ()=>onSubmitOperation(operation, editData) }>
            {operation === "delete" ? 
                <Typography>
                    {`${t("DeleteUserConfirmation")} "${editData.userName}".`}
                </Typography>
            :
            <>
                <TextBox label={t("Username")} labelMode="floating" value={editData.userName} onValueChanged={event=>handleChangeUserName(event.value)}/>
                
                {operation === "create" ?
                    <TextBox mode="password" label={t("Password")} labelMode="floating" value={editData.password} onValueChanged={event=>handleChangePassword(event.value)}/>
                :
                    <PasswordInput label="Resetar senha" value={editData.resetPassword} setValue={(event)=>{handleChangeResetPassword(event.value)}} disabled={false}/>
                }

                <div style={{marginTop: "1.5rem", marginBottom: "1rem"}}>
                    <CheckBox
                        text="Forçar alteração de senha no primeiro acesso"
                        value={editData.forcePasswordChange}
                        onValueChanged={(e) => setEditData(prevState => ({...prevState, forcePasswordChange: e.value}))}
                    />
                </div>

                <Divider/>
                <div style={{display: "flex", alignItems: "flex-end", fontWeight: "700", justifyContent: "space-between", marginTop: "1rem", marginBottom: "1rem"}}>
                    <div style={{color: "#333" }} >{t("Roles")}</div>
                    <div><Button size="small" variant="contained" color="primary" startIcon={<img src={addIcon}/>} disabled={editData.roles.length === allowedRoles.length || editData.roles.some(role=> role.roleId === null)} onClick={handleAddRole}>{t("AddRole")}</Button></div>
                </div>
                <div style={{display: "flex", flexDirection: "column", rowGap: "0.5rem"}}>
                    { editData.roles.map((role, index)=> <RoleInput userLevel={userLevel} index={index} handleDeleteRole={handleDeleteRole} key={role.externalId} usedRoles={editData.roles} data={role} roles={allRoles} services={allServices} handleChangeValue={handleChangeRoleService}/>)}
                </div>

                {editData.roles.some(r => r.roleId === allRoles.find(role => role.roleName === "supplier")?.roleId) && (
                    <div style={{marginTop: "1.5rem"}}>
                        <SelectBox
                            label={t("LinkedSupplier")}
                            dataSource={suppliers}
                            valueExpr="supplierId"
                            displayExpr="description"
                            value={editData.supplierId}
                            onValueChanged={event => setEditData(prev => ({...prev, supplierId: event.value}))}
                        />
                    </div>
                )}
            </>
        }
        </AdminDialog>
    )

}

export {UserDialogue}